import { CosProgress } from './CosProgress'

export default CosProgress
